module.exports = __webpack_public_path__ + "static/media/ruffles-crunch-teen-burger-mb-fr.b8fd20e8.jpg";